import '@ofuro/env/constant';
import '../types/types.d.ts';

import { setupGlobal } from '@ofuro/env/global';

setupGlobal();
